import type {
  LoginRequest,
  RefreshTokenResponse,
  SocialLoginRequest,
  SignupRequest,
  VerifyPasswordRequest,
  TokenResponse
} from "../../domain/types/auth";
import {
  RefreshTokenResponseSchema,
  TokenResponseSchema,
  WorkspaceSelectionRequiredError,
  isWorkspaceSelection,
} from "../../domain/types/auth";
import type { AuthRepository } from "../../domain/repositories/auth-repository";
import { authApiService } from "../api/auth-api-service";

export class AuthRepositoryImpl implements AuthRepository {
  async verifyPassword(request: VerifyPasswordRequest): Promise<boolean> {
    const response = await authApiService.verifyPassword(request);

    if (response.data) {
      return response.data;
    }

    throw new Error(response.errorMsg || "비밀번호 검증 실패.");
  }

  async socialLogin(request: SocialLoginRequest): Promise<TokenResponse> {
    const response = await authApiService.socialLogin(request);

    // 여러 회사에 속한 계정: 토큰 대신 워크스페이스 목록이 온다
    if (isWorkspaceSelection(response.data)) {
      throw new WorkspaceSelectionRequiredError(response.data);
    }
    if (response.data) {
      return TokenResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "소셜 로그인 실패.");
  }

  async signup(request: SignupRequest): Promise<boolean> {
    const response = await authApiService.signup(request);

    if (response.data) {
      return response.data;
    }

    throw new Error(response.errorMsg || "회원가입 실패.");
  }

  async reissue(refreshToken: string): Promise<RefreshTokenResponse> {
    const response = await authApiService.reissue(refreshToken);

    if (response.data) {
      return RefreshTokenResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "토큰 재발급 실패");
  }

  async login(request: LoginRequest): Promise<TokenResponse> {
    const response = await authApiService.login(request);

    // 여러 회사에 속한 계정: 토큰 대신 워크스페이스 목록이 온다
    if (isWorkspaceSelection(response.data)) {
      throw new WorkspaceSelectionRequiredError(response.data);
    }
    if (response.data) {
      return TokenResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "로그인 실패.");
  }

  async logout(): Promise<void> {
    // TODO: Implement logout logic when API is available
  }
}